module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-bg-1-sp-d7847f158704e5d7be478dc6cfe911f6.png";